/**
 * @file: useDefectiveBadgeColorMap.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { usePresentationTheme } from '@euler/app/tv/theme';
import { defectiveLevelTokenMapToValueMap } from '@euler/model';
import { useMemo } from 'react';

export const useDefectiveBadgeColorMap = () => {
  const theme = usePresentationTheme();
  return useMemo(
    () => defectiveLevelTokenMapToValueMap(theme.task.defectiveBadge.bgColor),
    [theme.task.defectiveBadge.bgColor],
  );
};
